import { Card, CardContent } from "@mui/material";

import { CardGrid } from "components/CardGrid";
import { FrmFieldGrid } from "components/FrmFieldGrid";
import { FrmSelectFromObjects } from "components/formFields/FrmSelectFromObjects";
import { FrmCheckbox } from "components/formFields/frm";

import { i18n } from "services/i18nService";
import {
  RATE_OPTIONS,
  CONFIRMATION_OPTIONS,
} from "services/sosInventoryService/upsShipment/schema";

export function ShippingOptions(props) {
  const { record, onChange, onScalarChangeAndFetchRates, isInError } = props;

  return (
    <Card variant="outlined">
      <CardContent>
        <CardGrid>
          <FrmFieldGrid gridAutoFlow="dense">
            <FrmSelectFromObjects
              name="rateType"
              label={i18n("frmLabel.Rate")}
              value={record.rateType ? { id: record.rateType } : null}
              onValueChange={onScalarChangeAndFetchRates}
              options={RATE_OPTIONS}
              disableClearable
              error={isInError("rateType")}
            />
            <FrmSelectFromObjects
              name="deliveryConfirmationCode"
              label={i18n("frmLabel.DeliveryConfirmation")}
              value={
                record.deliveryConfirmationCode
                  ? { id: record.deliveryConfirmationCode }
                  : null
              }
              onValueChange={onScalarChangeAndFetchRates}
              options={CONFIRMATION_OPTIONS}
              error={isInError("deliveryConfirmationCode")}
              disableClearable
            />
            <FrmCheckbox
              name="additionalHandling"
              label={i18n("frmLabel.AdditionalHandling")}
              onValueChange={onChange}
              value={record.additionalHandling}
            />
          </FrmFieldGrid>
        </CardGrid>
      </CardContent>
    </Card>
  );
}
